var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-checkbox-buttons"},[_c('BFormRadioGroup',_vm._g(_vm._b({attrs:{"checked":_vm.value,"buttons":"","button-variant":"checkbox"}},'BFormRadioGroup',_vm.$attrs,false),_vm.$listeners))],1)}
var staticRenderFns = []

export { render, staticRenderFns }